import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { validateRedirectUrl } from '../../../utils/validate-redirect';

/**
 * Custom hook to handle redirect URLs in authentication flows.
 * Uses sessionStorage instead of localStorage for better security (cleared on tab close).
 * Does NOT store tokens - tokens should be managed by the auth library or httpOnly cookies.
 *
 * @returns An object containing the validated redirect URL and encoded search params
 */
export function useAuthRedirect() {
  const [query] = useSearchParams();

  const rawRedirectUrl = query.get('redirect');

  // Validate redirect URL to prevent open redirect vulnerabilities
  const validatedRedirectUrl = useMemo(() => validateRedirectUrl(rawRedirectUrl), [rawRedirectUrl]);

  const encodedRedirect = useMemo(
    () => encodeURIComponent(validatedRedirectUrl),
    [validatedRedirectUrl],
  );

  const redirectSearch = useMemo(() => `redirect=${encodedRedirect}`, [encodedRedirect]);

  return {
    redirectUrl: validatedRedirectUrl,
    encodedRedirect,
    redirectSearch,
  };
}
